import { fetchDataPromise } from '../index';

export const getVisualData = (resolve, reject, token, projectSeq) => {
    let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/floorplanlist?projectSeq=' + projectSeq;
    let req = new Request(requestURL, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Authorization' : token,
        'Content-Type' : 'application/json'
      }
    });

    fetchDataPromise(req, 'getVisualData', resolve, reject);
}

export const getVisualDataId = (resolve, reject, token, projectSeq) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/floorplanlistid?projectSeq=' + projectSeq;
  let req = new Request(requestURL, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    }
  });

  fetchDataPromise(req, 'getVisualData', resolve, reject);
}

export const getFloorPlanDetail = (resolve, reject, token, floorId) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/floordetail?floorId=' + floorId;
  let req = new Request(requestURL, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    }
  });

  fetchDataPromise(req, 'getVisualData', resolve, reject);
}

export const getAvaliableDeviceData = (resolve, reject, token, groupId, siteId) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/getavaliabledevice?groupId=' + groupId + '&siteId=' + siteId, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    }
  });

  fetchDataPromise(req, 'getAvaliableDeviceData', resolve, reject);
}

export const getVirtualDeviceData = (resolve, reject, token, graphId) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/getvirtualdevice?graphId=' + graphId, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    }
  });

  fetchDataPromise(req, 'getAvaliableDeviceData', resolve, reject);
}


export const saveVisualGraphData = (resolve, reject, token, wallData, graphId, scale, scaleLine, deviceData, channelRecommendationConfig) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/savevisualgraph'
  let urlParm = `?graphId=${graphId}&scaleLine=${scaleLine}&scale=${scale}`;
  let req = new Request(requestURL + urlParm, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      wallData,
      deviceData,
      channelRecommendationConfig,
    })
  });

  fetchDataPromise(req, 'saveVisualGraphData', resolve, reject);
}

export const saveScaleData = (resolve, reject, token, graphId, scale, scaleLine) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/save-scale'
  let urlParm = `?graphId=${graphId}&scaleLine=${scaleLine}&scale=${scale}`;
  let req = new Request(requestURL + urlParm, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
  });
  fetchDataPromise(req, 'saveScaleData', resolve, reject);
}

export const saveChannelRecommendation = (resolve, reject, token, graphId, channelRecommendationConfig) => {
  const requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/save-channel-recommendation'
  const urlParm = `?graphId=${graphId}`;
  const req = new Request(requestURL + urlParm, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({channelRecommendationConfig})
  });
  fetchDataPromise(req, 'saveChannelRecommendation', resolve, reject);
}

export const getInteriorGraphById = (resolve, reject, token, graphId) => {
  const requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/get-interior-graph'
  const urlParm = `?graphId=${graphId}`;
  const req = new Request(requestURL + urlParm, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
  });
  fetchDataPromise(req, 'getInteriorGraphById', resolve, reject);
}

export const saveVisualManagerDataList = (resolve, reject, saveBodyData, mod, token) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/savevisualmanagerlist'
  let urlParm = '?saveMod='+ mod
  let req = new Request(requestURL + urlParm, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(saveBodyData)
  });

  fetchDataPromise(req, 'savevisualmanagerlist', resolve, reject);
}

export const getModalVisualData = (resolve, reject, token, requestBody) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/getvisualmanager';
  let req = new Request(requestURL, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: requestBody
  });

  fetchDataPromise(req, 'getModalVisualData', resolve, reject);
}

export const delVisualManagerData = (resolve, reject, delVisualManagerBody, token) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] + '/delvisualmanager';
  let req = new Request(requestURL, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(delVisualManagerBody)
  });

  fetchDataPromise(req, 'savevisualmanager', resolve, reject);
}

export const getHeatmapData = (resolve, reject, requestBody, authToken) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] +'/getheatmap' , {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : authToken,
    },
    body: requestBody
  });

  fetchDataPromise(req, 'getHeatmapData', resolve, reject);

}

// export const getHeatmapData = (resolve, reject, requestBody, authToken) => {
//   let req = new Request('http://10.5.88.59:8000/api/v1/heatmap' , {
//     method: 'POST',
//     mode: 'cors',
//     body: requestBody
//   });

//   fetchDataPromise(req, 'getHeatmapData', resolve, reject);

// }

export const saveVirtualDeviceInfo = (resolve, reject, authToken, requestBody, graphId) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] +'/virtualdevice?graphId=' + graphId , {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : authToken,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(requestBody)
  });

  fetchDataPromise(req, 'saveVirtualDeviceInfo', resolve, reject);
}

export const deleteVirtualDeviceInfo = (resolve, reject, authToken, virtualDeviceId) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] +'/virtualdevice/' + virtualDeviceId, {
    method: 'DELETE',
    mode: 'cors',
    headers: {
      'Authorization' : authToken,
    },
  });

  fetchDataPromise(req, 'deleteVirtualDeviceInfo', resolve, reject);
}

export const saveFloorPlanData = (resolve, reject, data, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] +'/floorplanproject' , {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(data)
    
  });

  fetchDataPromise(req, 'saveFloorPlanData', resolve, reject);
}

export const deleteFloorPlanData = (resolve, reject, seq, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] +'/floorplanproject/' + seq , {
    method: 'DELETE',
    mode: 'cors',
    headers: {
      'Authorization' : token,
    },
    
  });

  fetchDataPromise(req, 'deleteFloorPlanData', resolve, reject);
}

export const getFloorPlanProjectList = (resolve, reject, token, site) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] +'/floorplanprojectlist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: site
  });

  fetchDataPromise(req, 'getFloorPlanProjectList', resolve, reject);
}

export const getHeatmapAllData = (resolve, reject, authToken, projectId, graphId, formData) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['visual'] +'/getallheatmap?id=' + projectId + '&graphId=' + graphId , {
    method: 'POST',
    headers: {
      'Authorization' : authToken,
    },
    body: formData,
  });

  fetchDataPromise(req, 'getHeatmapAllData', resolve, reject);

}

